import { NavLink } from "react-router-dom";
import { FileText, Gauge, Home, Stethoscope, Wrench } from "lucide-react";
import { useApp } from "@/context/AppContext";

const TABS = [
  { to: "/", label: "Início", I: Home, id: "inicio" },
  { to: "/tratamento-de-ruidos", label: "Serviços", I: Wrench, id: "servicos" },
  { to: "/diagnostico", label: "Diagnóstico", I: Gauge, id: "diagnostico" },
  { to: "/orcamento", label: "Orçamento", I: FileText, id: "orcamento" },
  { to: "/dr-ruidos", label: "Dr. Ruídos", I: Stethoscope, id: "dr" },
];

export const MobileTabBar = () => {
  const { sel } = useApp();
  return (
    <nav className="no-print fixed inset-x-0 bottom-0 z-50 border-t border-slate-800 bg-[#0B0F17]/95 backdrop-blur-md xl:hidden" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="mobile-tab-bar">
      <div className="grid grid-cols-5">
        {TABS.map(({ to, label, I, id }) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={`tab-${id}`}
            className={({ isActive }) => `relative flex flex-col items-center gap-1 py-2.5 text-[10px] font-semibold uppercase tracking-wide transition-colors ${isActive ? "text-red-500" : "text-slate-400"}`}>
            <I className="h-5 w-5" />
            {label}
            {id === "orcamento" && sel.length > 0 && (
              <span className="absolute right-[22%] top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[9px] text-white" data-testid="tab-orcamento-badge">{sel.length}</span>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
